class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    document.addEventListener('scroll', this.handleStickyMobileBar);
    this.handleStickyMobileBar();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.dispatchVariantChange();
    }
    this.updateStickyMobileBar();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent(
        'variant-change',
        {
          bubbles: true,
          variant: this.currentVariant,
          detail: {
            variant: this.currentVariant
          }
        }
      )
    );
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        if (this.currentVariant) {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }

        // Update the inventory quantity hidden input
        const inventoryQtyDestination = document.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
        const inventoryQtySource = html.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
        inventoryQtyDestination.value = inventoryQtySource.value;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButtons = document.getElementById(`product-form-${this.dataset.section}`)?.querySelectorAll('[name="add"]');

    if (!addButtons) return;

    if (disable) {
      addButtons.forEach((addButton) => {
        addButton.setAttribute('disabled', true);
      });
      if (text) {
        addButtons.forEach((addButton) => {
          // Check if it's a special pdp sticky action button
          if(addButton.hasAttribute('data-product-sticky-button')) {
            addButton.querySelector('span').textContent = text;
          } else {
            addButton.querySelector('.text').textContent = text;
          }
        });
      }
    } else {
      addButtons.forEach((addButton) => {
        addButton.removeAttribute('disabled');
        // Check if it's a special pdp sticky action button
        if(addButton.hasAttribute('data-product-sticky-button')) {
          addButton.querySelector('span').textContent = window.variantStrings.addPlus;
        } else {
          addButton.querySelector('.text').textContent = window.variantStrings.addToCart;
        }
      });
    }

    if (!modifyClass) return;
  }

  /**
   * handleStickyMobileBar
   */
  handleStickyMobileBar(){
    const productFormButtons = document.querySelector('.product-form__buttons');
    const remainingScrollHeight = (productFormButtons.getBoundingClientRect().top + productFormButtons.clientHeight);
    const newslettersPos = document.querySelector('#shopify-section-newsletter').offsetTop - (window.outerHeight * 0.25);
    if(remainingScrollHeight <= 0 && window.scrollY <= newslettersPos) {
      document.querySelector('[data-product-sticky-action]').classList.add('product-sticky-action--active');
      document.querySelector('#cart-notification').classList.add('cart-notification--with-sticky-add-to-cart');
    } else {
      document.querySelector('[data-product-sticky-action]').classList.remove('product-sticky-action--active');
      document.querySelector('#cart-notification').classList.remove('cart-notification--with-sticky-add-to-cart');
    }
  }

  /**
   * updateStickyMobileBar
   * @description Update variant bar values when switched
   */
  updateStickyMobileBar() {
    const parent = this.querySelector('input[name="id"]:checked').parentNode;
    const parentData = parseJson(parent.dataset.variant);
    document.querySelector('[data-product-sticky-variant]').innerHTML = parentData.title;
    document.querySelector('[data-product-sticky-price]').innerHTML = `— ${parentData.price}`;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || parseJson(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}

class VariantIdSelector extends VariantSelects {
  constructor() {
    super();
  }

  // Get ID instead of options
  updateOptions() {
    this.querySelectorAll('input[name="id"]:checked')?.forEach((checkbox) => {
      if (checkbox.checked) {
        this.id = checkbox.value;
      }
    })
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return variant.id == this.id;
    });
  }
}

if (!customElements.get('variant-selector')) {
  customElements.define('variant-id-selector', VariantIdSelector);
}

class PersonalMessage extends HTMLElement {
  constructor() {
    super();
    this.querySelector('textarea').addEventListener('keyup', this.onMessageChange);
  }

  onMessageChange() {
    document.querySelector(`[data-personal-message-field]`).value = this.value;
  }
}

if (!customElements.get('personal-message')) {
  customElements.define('personal-message', PersonalMessage);
}
